export * from './university-form-page.component';
